<script lang="ts" setup>
import PrintingOrderSupplierForm from "@/data-views/forms/printing_order_supplier/Form.vue";
definePage({
  meta: {
    action: "update",
    subject: "PrintingOrderSupplier",
  },
});
</script>

<template>
  <div>
    <PrintingOrderDeprecationNotice />
    <PrintingOrderSupplierForm />
  </div>
</template>

<style lang="scss">
@use "@core/scss/template/libs/apex-chart.scss";
</style>
